import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';
import LandingPage          from './pages/LandingPage';
import RegisterPage         from './pages/RegisterPage';
import LoginPage            from './pages/LoginPage';
import Dashboard            from './pages/Dashboard';
import MyReferrals          from './pages/MyReferrals';
import MyRewards            from './pages/MyRewards';
import ContactPage          from './pages/ContactPage';
import ViewerReferralsPage  from './pages/ViewerReferralsPage';
import UserDashboardPage    from './pages/UserDashboardPage';
import AdminUsersPage       from './pages/AdminUsersPage';
import AdminDashboardPage   from './pages/AdminDashboardPage';

function PageLayout() {
  return <div className="page-wrap"><Outlet /></div>;
}

export default function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route element={<PageLayout />}>
          <Route path="/register"      element={<RegisterPage />} />
          <Route path="/login"         element={<LoginPage />} />
          {/* Referral (student) routes */}
          <Route path="/dashboard"     element={<ProtectedRoute allowedRoles={['referrer','student']}><Dashboard /></ProtectedRoute>} />
          <Route path="/referrals"     element={<ProtectedRoute allowedRoles={['referrer','student']}><MyReferrals /></ProtectedRoute>} />
          <Route path="/rewards"       element={<ProtectedRoute allowedRoles={['referrer','student']}><MyRewards /></ProtectedRoute>} />
          {/* User (viewer) routes */}
          <Route path="/view/referrals" element={<ProtectedRoute allowedRoles={['councillor','admin']}><ViewerReferralsPage /></ProtectedRoute>} />
          <Route path="/view"           element={<ProtectedRoute allowedRoles={['councillor','admin']}><UserDashboardPage /></ProtectedRoute>} />
          {/* Admin routes */}
          <Route path="/admin"          element={<ProtectedRoute allowedRoles={['admin']}><AdminDashboardPage /></ProtectedRoute>} />
          <Route path="/admin/users"    element={<ProtectedRoute allowedRoles={['admin']}><AdminUsersPage /></ProtectedRoute>} />
          <Route path="/contact"       element={<ContactPage />} />
          <Route path="*"              element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
